import { parseClaims } from "../lib/parseClaims.js";
import { JwtStorage } from "../lib/JwtStorage";
import { LoginManager } from "../lib/LoginManager";
import router from "@/router/index.js";

const loginManager = new LoginManager();

function getDefaultState() {
  return {
    id: "",
    email: "",
    token: "",
    refreshToken: "",
    claims: [],
    userName: "",
    role: "",
    isLoggedIn: () => !!this.token && !!this.claims
  };
}

const state = getDefaultState();

const actions = {
  reset({ commit }) {
    JwtStorage.clear();
    commit('mReset');
  },
  logout({ commit }) {
    JwtStorage.clear();
    localStorage.clear();
    commit('mReset');
  },
  async tryLogin({ commit }, creds) { 
    const result = await loginManager.tryLogin(creds);

    if (!result.success) {
      console.error(result);
      return false;
    }

    commit('mSet', result.payload);
    JwtStorage.updateKeys(result.payload.token, result.payload.refreshToken);
    return true;
  },

  async reapplyToken({ commit }) { 
    var result;
    if (!JwtStorage.exists()) {
      JwtStorage.clear();
      commit("mReset");
       result = await loginManager.tryLogin();

      if (result.success) { 
        commit("mSet", result.payload);
        JwtStorage.updateKeys(result.payload.token, result.payload.refreshToken);
        return;
      }
      console.error('UNABLE TO AUTHENTICATE USER!');
      router.push({ name: 'Login' })
      return;
    }

    result = await loginManager.tryRefreshJwt();

    if (result.success) { 
      commit("mSet", result.payload);
      JwtStorage.updateKeys(result.payload.token, result.payload.refreshToken);
      return;
    }

    JwtStorage.clear();
    console.error(result.error);
  }, 
};


const mutations = {
  mReset(state) {
    Object.assign(state, getDefaultState());
  },
  mSet(state, payload) {
    state.claims = parseClaims(payload.token);
    state.userName = payload.name;
    state.email = payload.email;
    state.id = payload.id;
    state.role = payload.role.name;
    state.token = payload.token;
    state.refreshToken = payload.refreshToken;
  },

  mRefresh(state, payload) {
    state.token = payload.token;
    state.refreshToken = payload.refreshToken;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
